import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatOption, MatSelect } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GenericSelectInputModule } from '@sla-ng/ui-material';
import { CostinglevelArticleMappingPage } from './costinglevel-article-mapping.page';

export * from './costinglevel-article-mapping.page';

const routes: Routes = [
    {
        path: '',
        component: CostinglevelArticleMappingPage,
    },
];

@NgModule({
    declarations: [ CostinglevelArticleMappingPage ],
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        MatInputModule,
        MatButtonModule,
        MatIconModule,
        MatProgressBarModule,
        MatTableModule,
        TranslateModule,
        MatPaginatorModule,
        ReactiveFormsModule,
        MatSortModule,
        MatTooltipModule,
        GenericSelectInputModule,
        MatSelect,
        MatOption,
    ],
})
export class CostinglevelArticleMappingPageModule {
}
